<template>

  <div class="sidebar-menu-admin">
      <div class="logo">
        <img src="@/assets/img/logo.png" alt />
      </div>

      <div class="user">

        <div class="content">
          <img src="https://image.flaticon.com/icons/svg/149/149072.svg" alt="">
           <span>{{usuario.nombre}}</span>
        </div>

        <div class="salir">
          <div class="salir-btn" @click="cerrarSesion">Cerrar sesión</div>
        </div>
        
      </div>

      <div class="links">
        <ul>
        <li>
          <router-link to="/admin">
            <i class="material-icons">dashboard</i>
            Reportes
          </router-link>
        </li>
        <li>
          <router-link to="/admin/ventas">
            <i class="material-icons">shopping_cart</i>
            Ventas 
          </router-link>
        </li>
        <li>
          <router-link to="/admin/ventas-no-stock">
            <i class="material-icons">remove_shopping_cart</i>
            Ventas sobre pedido
          </router-link>
        </li>
        <li>
          <router-link to="/admin/ventas/agregar">
            <i class="material-icons">add_circle</i>
            Agregar venta
          </router-link>
        </li>
          
        <li>
          <router-link to="/admin/gastos">
            <i class="material-icons">credit_card</i>
            Gastos
          </router-link>
        
        </li>

        <li>
          <router-link to="/admin/agregar-gasto">
            <i class="material-icons">add_circle</i>
            Agregar gasto
          </router-link>
        
        </li>
          
      
        <li>
          <router-link to="/admin/productos">
            <i class="material-icons">local_mall</i>
            Productos
          </router-link>
         
        </li>
        <li>
          <router-link to="/admin/categorias">
            <i class="material-icons">layers</i>
            Categorías
          </router-link>
         
        </li>
        <li>
          <router-link to="/admin/mensajes">
            <i class="material-icons">message</i>
            Mensajes
          </router-link>
         
        </li>
      </ul>
      </div>


  </div>


</template>

<script>
import { mapState, mapActions } from "vuex";
const axios = require("axios");
export default {
  name: "Menu",

  data: () => {
    return {
      menu: [
        {
          header: true,
          title: "Reportes",
          hiddenOnCollapse: true,
          
        },
        {
          href: "/",
          title: "Dashboard",
          icon: "fa fa-user",
          child: [
            {
              href: "/charts/sublink",
              title: "Sub Link"
            }
          ]
        },
        {
          href: "/charts",
          title: "Charts",
          icon: "fa fa-chart-area",
          child: [
            {
              href: "/charts/sublink",
              title: "Sub Link"
            }
          ]
        }
      ]
    };
  },
  methods: {
    ...mapActions(["cerrarSesion"])
  },
  mounted() {},
  computed: {
    ...mapState(["usuario"])
  }
};
</script>

